import * as Logger from '../common/tools/logger';
import { PermissionClientCompat } from './app/permission-client-compat-app';

const client = new PermissionClientCompat();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const win = window as any;

win.PermissionClientCompat = client;
Logger.debug('PermissionClientCompat', 'global', 'initializing compat layer');

export default client;
